import Marionette from 'backbone.marionette';
import billDetailVersionItemviewTmpl from '../templates/bill_detail_version_itemview.tpl';
export default Marionette.ItemView.extend({
  template: billDetailVersionItemviewTmpl,
  tagName: "p"
});